import { render, staticRenderFns } from "./CompanySkillsInventoryTable.vue?vue&type=template&id=52056eac&scoped=true&"
import script from "./CompanySkillsInventoryTable.vue?vue&type=script&lang=js&"
export * from "./CompanySkillsInventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./CompanySkillsInventoryTable.vue?vue&type=style&index=0&id=52056eac&lang=scss&scoped=true&"
import style1 from "./CompanySkillsInventoryTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52056eac",
  null
  
)

export default component.exports